export const agenda = {
  agendaDuration: 'czas trwania',
  agendaCurtainCopy: 'Skopiuj link',
  agendaCurtainFlag: 'Oflaguj treść',
  agendaCurtainFlagSent: 'Treść zgłoszona',
  agendaLinkCopied: 'Link skopiowany!',
  agendaStartsAt: 'Rozpoczyna się o ',
  agendaEndsAt: 'Kończy się o ',
  agendaSpeakers: 'Prelegenci',
  agendaSeeAllSpeakers: 'Zobacz wszystkich',
  agendaAddToSchedule: 'Dodaj do mojego harmonogramu',
  agendaRemoveFromSchedule: 'Usuń z mojego harmonogramu',
  agendaAddedToSchedule: 'Dodano do mojego harmonogramu!',
  agendaRemovedFromSchedule: 'Usunięto z mojego harmonogramu!',
  agendaCalendar: 'Kalendarz',
  agendaAddToCalendar: 'Dodać do kalendarza systemowego?',
  agendaCalendarSkip: 'Pomiń',
  agendaCalendarAdd: 'Dodaj',
  agendaNow: 'TERAZ',
  agendaModerators: 'Moderatorzy',

  QnATitle: 'Sesja pytań i odpowiedzi',
  askASpeaker: 'Zadaj pytanie prelegentowi',
  askAQuestion: 'Zadaj pytanie',
  askQuestionPlaceholder: 'Wpisz tutaj swoje pytanie',
  cancel: 'Anuluj',
  ask: 'Zadaj',
  deleteConfirmation: 'Czy chcesz usunąć to pytanie?',
  questionDeleted: 'Pytanie zostało pomyślnie usunięte!',
  rateSession: 'Oceń tę sesję'
}
